import styled from 'styled-components'
import theme from 'presentation/styles/theme'

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CardTitle = styled.div<{
  color?: keyof typeof theme.ds.colors
}>`
  display: flex;
  gap: 8px;
  align-items: center;
  svg {
    path {
      fill: ${({ theme, color = 'terciary400' }) => theme.ds.colors[color]};
    }
  }
`

export const Quote = styled.div<{
  color?: keyof typeof theme.ds.colors
}>`
  border-left: ${({ theme, color = 'terciary400' }) =>
    `1px solid ${theme.ds.colors[color]}`};
  padding: 8px 0 0 8px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 1.3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 3.9em;
`
